/**
 * Converte string de preço no formato brasileiro para número
 * Exemplos: "R$ 1.234,56" -> 1234.56, "R$ 50,00" -> 50.00
 */
export function parsePrice(priceString: string): number {
  if (!priceString) return 0;
  
  // Remove "R$ " e espaços extras
  const cleaned = priceString.replace(/R\$\s?/g, '').trim();
  
  // Remove pontos (separadores de milhares) e substitui vírgula por ponto decimal
  const normalized = cleaned.replace(/\./g, '').replace(',', '.');
  
  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? 0 : parsed;
}

/**
 * Formata número para string de preço brasileiro
 * Exemplo: 1234.56 -> "1.234,56"
 */
export function formatPrice(price: number): string {
  return price.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

/**
 * Formata número para moeda brasileira
 * Exemplo: 1234.56 -> "R$ 1.234,56"
 */
export function formatCurrency(price: number): string {
  return price.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
}